
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/live-screenshot",
      function () {
        return require("private-next-pages/android/local/live-screenshot/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/live-screenshot"])
      });
    }
  